import { getSetPublicAction } from '@/utils/common/tableActions'

export default {
  created () {
    this.singleActions = [
      {
        label: this.$t('common.action.edit'),
        permission: 'bastion_hosts_update',
        action: obj => {
          this.createDialog('BastionCreateOrUpdateDialog', {
            data: [obj],
            onManager: this.onManager,
            success: () => {
              this.refresh()
            },
          })
        },
      },
      {
        label: this.$t('common.more'),
        actions: obj => {
          return [
            {
              label: this.$t('common_641', [this.$t('dictionary.project')]),
              action: () => {
                this.createDialog('ChangeOwenrDialog', {
                  data: [obj],
                  columns: this.columns,
                  name: this.$t('dictionary.network'),
                  onManager: this.onManager,
                  resource: 'networks',
                  ignoreCandidateDomains: true,
                })
              },
              meta: () => {
                const ret = {
                  validate: false,
                  tooltip: '',
                }
                if (this.isProjectMode) {
                  ret.tooltip = this.$t('bastionHost.user_permission_check', [this.$t('dictionary.domain')])
                  return ret
                }
                if (obj.is_public && obj.public_scope !== 'none') {
                  ret.validate = false
                  ret.tooltip = this.$t('common_280')
                  return ret
                }
                return {
                  validate: this.isPower(obj),
                }
              },
            },
            getSetPublicAction(this, {
              name: this.$t('bastionHost.title'),
              scope: 'project',
              resource: 'bastion_hosts',
            }),
            {
              label: this.$t('table.action.delete'),
              permission: 'bastion_hosts_delete',
              action: () => {
                this.createDialog('DeleteResDialog', {
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  title: this.$t('table.action.delete'),
                  name: this.$t('bastionHost.title'),
                  onManager: this.onManager,
                })
              },
              meta: () => this.$getDeleteResult(obj),
            },
          ]
        },
      },
    ]
  },
}
